import { render, staticRenderFns } from "./ConsultantsByVendor.vue?vue&type=template&id=10ffbe53&"
import script from "./ConsultantsByVendor.vue?vue&type=script&lang=js&"
export * from "./ConsultantsByVendor.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantsByVendor.vue?vue&type=style&index=0&id=10ffbe53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports